// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2e32ec52","239":"52868183","455":"765e1d6b"}[chunkId] + ".chunk.js";
};